/**
 * Define new feature flags here. Please make sure that your code works with the feature flag disabled!
 *
 * Feature flags will use the following values:
 * - The first source, if defined there. Otherwise, the next source in the list will be used.
 * - If no sources in the list have a value defined, the defaultValue will be used.
 *
 * If source "client" is defined, the feature flag can be enabled/disabled by the user in the debug helper.
 * If source "envvar" is defined, an `envVar` has to be defined, prefixed with NEXT_PUBLIC_.
 */
// try exporting as separate consts
// TODO: this needs be properly typed!
export const featureFlagsDefinition = {
    // Feature flags for tests
    // Use for playwright tests only
    // Only visible when running tests!
    TEST_CLIENT_FEATURE_FLAG: {
        title: 'TEST',
        description: 'Use for test only',
        sources: ['client'],
        defaultValue: false,
        tags: ['nmp'],
    },
    // Feature flag for tests
    // Use for playwright tests only
    // Only visible when running tests!
    TEST_ENV_VAR_FEATURE: {
        title: 'Show feature flag with source envvar',
        description: 'Use for test only',
        sources: ['envvar'],
        defaultValue: true,
        tags: ['nmp'],
    },
    ENABLE_OFFER_RECHTSSCHUTZ: {
        title: 'Aktiviert Feature Rechtschutz Angebot erstellen',
        description: 'Aktiviert Feature Rechtschutz Angebot erstellen anzeigen',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal'],
    },
    ENABLE_360_GRAD_ANSICHT: {
        title: 'Aktiviert Feature 360 Grad Ansicht',
        description: 'Aktiviert Feature 360 Grad Ansicht',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal'],
    },
    SHOW_ALL_VEHICLE_TYPE_OPTIONS: {
        title: 'Alle Fahrzeugtypen anzeigen',
        description: 'Zeigt beim Select Feld "Fahrzeugtyp" alle (je nach Rolle möglichen) Optionen an (zB. PKW, LKW, Wohnmobil). Wenn false, dann wird nur der PKW als einzige Auswahlmöglichkeit angezeigt.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['nmp'],
    },
    SHOW_CHANGE_PAYMENT_INTERVAL_INKASSO: {
        title: 'Zahlungsinformationen bei Inkasso bearbeiten',
        description: 'Unter bestimmten Vorraussetzungen (offer.system === INSIS && offer.paymentWay === Bankinkasso) ist ein Bearbeiten des Zahlungsintervalls + anhängen von Dokumenten via Modal möglich.',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal'],
    },
    ENABLE_UNSTABLE_FEATURES: {
        title: 'Zeige alle nicht stabilen Features an',
        description: 'Zeigt folgende Features an: Wub alle Fragen, Fahrzeuge erfassen Leasingfahrzeug, MVST Befreiung, aktiviert Kasko und Insassenunfall, alle Produktioptionen, alle Bonusoptionen, alle Bonus/Malus Daten Felder, aktiviert Zahlungsweise optionen',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['nmp'],
    },
    ENABLE_BONUSGIFTS_API_VALIDATION: {
        title: 'Aktiviere die API Validierung für die Bonusgeschenke',
        description: 'Verwendet die neuen Components für die Bonusgeschenke Polizzen Inputs inkl. API Validierung',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp'],
    },
    ENABLE_CHASSISNUMBER_API_VALIDATION: {
        title: 'Aktiviere die API Validierung für die Fahrgestellnummer',
        description: 'Aktiviert die API Validierung der Fahrgestellnummer',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp'],
    },
    FINANCE_INKASSO: {
        title: 'Finance Inkassodetails bearbeiten',
        description: 'Ermöglicht das Bearbeiten von Buchungen und Funktionen wie Guthaben ausbezahlen',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal', 'finance'],
    },
    ENABLE_DOCUMENT_VALIDATION: {
        title: 'Document Validation',
        description: 'Enables validation of document uploads',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['portal', 'document'],
    },
    RISKINE_BUTTON: {
        title: 'Riskine Button PROD',
        description: 'Switches TEST/UAT or PROD Button(s)',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal', 'riskine'],
    },
    FINANCE_DUNNING: {
        title: 'Finance Mahnung',
        description: 'Ermöglicht das Anzeigen von mahnspezifischen Daten',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal', 'finance'],
    },
    FINANCE_DUNNING_COVERFREEPERIOD_MODAL: {
        title: 'Finance CoverFreePeriod Modal',
        description: 'Ermöglicht das Hinzufügen und Bearbeiten von deckungsfreien Zeiten',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal', 'finance'],
    },
    FINANCE_DUNNING_END: {
        title: 'Finance Dunning Mahnstopp anzeigen',
        description: 'Einblenden der Informationen zu Mahnstopp',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['portal', 'finance'],
    },
    FINANCE_DUNNING_FINISH: {
        title: 'Finance Dunning Mahnverfahren Beenden',
        description: 'Ermöglicht das Beenden eines Mahnverfahrens',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal', 'finance'],
    },
    FINANCE_PAYMENTREQUEST_WRITEOFF: {
        title: 'Finance PaymentRequest WriteOff',
        description: 'Ermöglicht das Klicken auf den Button um einen WriteOff zu triggern',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal', 'finance'],
    },
    FINANCE_PAYMENTREQUEST_REVERSE_WRITEOFF: {
        title: 'Finance PaymentRequest Reverse WriteOff',
        description: 'Ermöglicht das Klicken auf den Button um einen Reverse WriteOff zu triggern',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal', 'finance'],
    },
    FINANCE_PAYMENTAPPLICATION_REBOOK: {
        title: 'Finance PaymentApplication Rebook',
        description: 'Ermöglicht das Klicken auf den Button um eine Rebook zu triggern',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal', 'finance'],
    },
    FINANCE_PAYMENTREFUND: {
        title: 'Finance PaymentRefund',
        description: 'Ermöglicht das Klicken auf den Button um Guthaben auszuzahlen',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal', 'finance'],
    },
    FINANCE_SHOW_BOOKINGDETAILS_TECHNICAL_DATA: {
        title: 'Finance Buchungsdetails Technische Daten anzeigen',
        description: 'Ermöglicht das Anzeigen von technische Werten in den Buchungsdetails',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['portal', 'finance'],
    },
    FINANCE_SHOW_PAYMENTDETAILS_TECHNICAL_DATA: {
        title: 'Finance Zahlungsdetails Technische Daten anzeigen',
        description: 'Ermöglicht das Anzeigen von technische Werten in den Zahlungsdetails',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['portal', 'finance'],
    },
    FINANCE_UNALLOCATED_PAYMENTS_ENABLE_EPOCH_CHECK: {
        title: 'Finance Unallocated Payments Epoch Check aktivieren',
        description: 'Ermöglicht das Aktivieren von dem Check für Epochs in der Unallocated Payments Ansicht',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['portal', 'finance'],
    },
    FINANCE_UNALLOCATED_PAYMENTS_ENABLE_IBAN_SEARCH: {
        title: 'Finance Unallocated Payments IBAN Suche aktivieren',
        description: 'Ermöglicht das Aktivieren von der Suche für IBAN',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['portal', 'finance'],
    },
    SHOW_CHANGE_OF_VEHICLE_BONUS: {
        title: 'Fahrzeugwechselbonus',
        description: 'Zeigt den Fahrzeugwechselbonus bei den Produktoptionen auf der Seite "Coverage" an.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['nmp'],
    },
    SHOW_ALL_BONUS_ADVANTAGE_OPTIONS: {
        title: 'einmaliger Bonusstufenvorteil (Freischaden)',
        description: 'Zeigt den einmaligen Bonusstufenvorteil (Freischaden) auf der Seite "Coverage" an.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['nmp', 'freischaden'],
    },
    CAMPAIGN_DISCOUNTS: {
        title: 'Aktionsnachlass',
        description: 'Zeigt den Aktionsnachlass in der Sidebar auf der Seite "Coverage" an.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['nmp'],
    },
    EMPLOYEE_DISCOUNTS: {
        title: 'Mitarbeiter Rabatt',
        description: 'Zeigt den Mitarbeiterrabatt in der Sidebar auf der Seite "Coverage" an.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['nmp'],
    },
    SHOW_INTERMEDIARY1_INTERMEDIARY2: {
        title: 'Vermittler 1 und Vermittler 2 in Weitere Optionen',
        description: 'Zeig Vermittler in der Sidebar auf der Seite "Coverage" an.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['nmp'],
    },
    SHOW_ALL_ENGINE_TYPE_OPTIONS: {
        title: 'Alle Antriebsarten anzeigen',
        description: 'Zeigt beim Select Feld "Antriebsart" alle Optionen an (zB. Benzin, Diesel, Elektro, Hybrid mit Elektromotor, Wasserstoff, Brennstoffzelle, ...). Wenn false, dann wird nur die eingeschränkte Auswahl von "Benzin", "Diesel", "Elektro", "Hybrid mit Elektromotor" und "Antriebsart nicht angeführt" angezeigt.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['nmp'],
    },
    ENABLE_APPLICATION_TYPE: {
        title: 'Antragsart ermöglichen',
        description: 'Das Feld Antragsart ist verfügbar und es kann zwischen Neuantrag und Ersatzantrag gewählt werden. Wenn "false", dann wird das Feld zwar angezeigt aber ist disabled und auf "Neuantrag" defaultiert.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['nmp'],
    },
    CREATEOFFER_KFAMODE: {
        title: 'KFA-Modus für Angebote',
        description: 'Erlaubt es, den KFA-Modus für Angebote auszuwählen.',
        sources: ['client', 'envvar'],
        defaultValue: 'selectable',
        possibleValues: ['never', 'always', 'selectable'],
        tags: ['offer'],
    },
    FAKE_EMPLOYEE_NUMBER: {
        title: 'Fake Employee Number',
        description: 'Erlaubt eine Fake Mitarbeiternummer bei denen die nicht über Okta einen bekommen. Darf niemals auf höheren stages wie PROD eingeschaltet werden',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['offer'],
    },
    UPLOAD_VERZICHTSERKLAERUNG: {
        title: 'Upload Verzichtserklärung',
        description: 'Aktiviert auf Seite ... unter Bonus den Upload für Verzichtserklärung.  Das Feld Antragsart ist verfügbar und es kann zwischen Neuantrag und Ersatzantrag gewählt werden. Wenn "false", dann wird das Feld zwar angezeigt aber ist disabled und auf "Neuantrag" defaultiert.',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp', 'bonus malus'],
    },
    PENDING_CLAIMS: {
        title: 'Unberücksichtigte Schäden',
        description: 'Aktiviert auf Seite 7 unter Bonus/Malus-Daten und erlaubt der Benutzer, Schäden einer Vorpolizze einzugeben.',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp', 'bonus malus'],
    },
    ALTERNATIVE_OFFER: {
        title: 'Alternativangebot',
        description: 'Aktiviert die Möglichkeit ein Alternativangebot ab Seite 7 zu erstellen',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp'],
    },
    POLICY_CHECK_BUTTON: {
        title: 'Vorpolizze Prüfen',
        description: 'Aktiviert auf Seite 7 unter Bonus/Malus-Daten den Button "Vorpolizze Prüfen".',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp', 'bonus malus'],
    },
    POLICY_WITH_OMDS: {
        title: 'Polizzierung mit OMDS freigeben',
        description: 'Aktiviert auf Seite 9 den Button -> Antrag zur Polizzierung freigeben (OMDS)".',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp', 'OMDS Host'],
    },
    GENERAL_AGREEMENT_OPTIONS: {
        title: 'Rahmenvereinbarungen',
        description: 'Blendet die Rahmenvereinbarungen-Optionen ein.',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp', 'dev-only'],
    },
    OBSERVATION_PERIOD: {
        title: 'Beobachtungszeitraum',
        description: 'Aktiviert auf Seite 7 unter Bonus/Malus-Daten und erlaubt der Benutzer, den Beobachtungszeitraum einer Vorpolizze zu bearbeiten.',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp', 'bonus malus'],
    },
    SIGN_MANUALLY: {
        title: 'Manuell Unterschreiben',
        description: 'Add a button to sign ELU manually without real signatures',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['nmp', 'dev-only'],
    },
    SHOW_CREATE_CLAIM_FORM: {
        title: 'Schadenanlage',
        description: 'Erlaubt es, das Formular für die Schadenanlage anzuzeigen.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['claim'],
    },
    CLAIM_EVENT_SEARCH: {
        title: 'Ereignissuche',
        description: 'Erlaubt es, nach Ereignissen zu suchen.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['claim', 'portal'],
    },
    SHOW_APPROVALS: {
        title: 'Genehmigungsdetails',
        description: 'Im Portal /party/:pId/offers gibt es einen neuen Menu-Button Genehmigung einsehen.',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['offer', 'portal'],
    },
    INSURANCE_CONFIRMATION_SEARCH: {
        title: 'Suche Versicherungsbestätigungen',
        description: 'In der globalen Suche nach Versicherungsbestätigungen suchen können.',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['product', 'portal'],
    },
    SHOW_PARTY_DOCUMENT: {
        title: 'Partner Dokument Upload',
        description: 'Im Portal /party/:pId/dokumente wird angezeigt. Es ist möglich Dokumente hochzuladen. Metadaten zu bearbeiten und zu löschen',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['party', 'portal'],
    },
    SHOW_TASKMGMT_REPORTING: {
        title: 'Taskmanagement Reporting',
        description: 'Im Taskmanagement wird der Reporting Tab angezeigt.',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['taskmanagement', 'portal'],
    },
    SHOW_TASKMGMT_TEMPLATE_EDITOR: {
        title: 'Taskmanagement Textbaustein-Verwaltung',
        description: 'Im Taskmanagement wird der Textbaustein-Verwaltung Tab angezeigt.',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['taskmanagement', 'portal'],
    },
    PARTY_NOTES: {
        title: 'Notizen beim Partner im Portal',
        description: 'Damit kann man Notizen zu jeden Kunden/Partner im Portal hinzufügen',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['party', 'portal'],
    },
    CONNECT_SHOW_AUTH_FEATURES: {
        title: 'Relevante Features für Login und Registrierung',
        description: 'Features für die Registrierung und Login anzeigen',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['connect'],
    },
    RECENT_PARTIES: {
        title: 'Recent parties history',
        description: 'Damit werden die zuletzt angesehenen Parties unter der Searchbar angezeigt',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['party', 'portal'],
    },
    SHOW_EVALUATIONS: {
        title: 'Show Evaluations',
        description: 'This means we will be able to access the evaluations navigation item',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['taskmanagement', 'portal'],
    },
    SHOW_OFFER: {
        title: 'Show Offer',
        description: 'Shows all offer-related content (currently: AgentOffers-Home, AgentOffers-Evaluations, "Beratung"-Tab in Sidebar)',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['offer', 'portal'],
    },
    SHOW_ALL_FIELDS_IN_CLAIM_CREATION: {
        title: 'Show all fields when creating a claim',
        description: 'If set to true it will also show fields that might not work yet',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['claim', 'portal'],
    },
    SHOW_MY_UPLOADS: {
        title: 'Show my uploads for a claim',
        description: 'If set to true it will show my uplods for a claim',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['claim', 'customer-portal'],
    },
    SHOW_ALL_TASKS_IN_PARTY: {
        title: 'Show all tasks in party',
        description: 'If set to true it will show all tasks tab in party',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['party', 'portal'],
    },
    SHOW_TM_INTERMEDIARY: {
        title: 'Show Intermediary in Intermediary Card',
        description: 'This means that u will see the intermediary chip in the intermediary card',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['taskmanagement', 'portal'],
    },
    ENABLE_GENERAL_FINANCE: {
        title: 'Freischalten der generellen Inkasso Übersicht',
        description: 'Zeigt das Icon zu Inkasso in der Sidebar',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['finance', 'portal'],
    },
    ENABLE_GENERAL_FINANCE_SEARCH: {
        title: 'Inkasso Bankbuchungen Suche',
        description: 'Ermöglicht die Suche von Inkasso Buchungen von der Bank',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['finance', 'portal'],
    },
    ENABLE_GENERAL_FINANCE_MONTHLYCLOSURE: {
        title: 'Inkasso Monatsschluss(TC)',
        description: 'Zeigt die Monatsschluss(TC) Übersicht',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['finance', 'portal'],
    },
    ENABLE_GENERAL_FINANCE_PAYMENTTYPE_UPLOAD: {
        title: 'Inkasso Buchungstexte CSV Upload',
        description: 'Ermöglicht den CSV Upload für Buchungstexte',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['finance', 'portal'],
    },
    ENABLE_POLICY_CANCELLATION: {
        title: 'Activate storno (policy cancelation)',
        description: 'Allows to cancel a contract',
        sources: ['client', 'envvar'],
        defaultValue: true,
        tags: ['customer-portal', 'portal'],
    },
    ENABLE_CONNECT_PARTY_VALIDATION: {
        title: 'Enables the party validation for connect',
        description: 'Features taht enables the party validation for connect',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['connect'],
    },
    ENABLE_AVOID_REFETCH_ZSI_REQUEST_ENTRY: {
        title: 'Aktiviert vermeinden von wiederladen der Request Entries auf der Request Detail Pages',
        description: 'Aktiviert vermeinden von wiederladen der Request Entries auf der Request Detail Pages',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal'],
    },
    ENABLE_ADVISORY_BUTTON_RISKINE: {
        title: 'Riskine "Produktberatung" Button/s',
        description: 'Aktiviert den/die Riskine "Produktberatung" Button/s',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal'],
    },
    ENABLE_AUTOMATION: {
        title: 'Automation',
        description: 'Aktiviert die Automation-Übersicht im Portal',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal'],
    },
    ENABLE_TESTDATA: {
        title: 'Testdaten',
        description: 'Aktiviert das Einspielen von Testdaten im Portal',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal'],
    },
    SHOW_TESTDATA_RESYNC: {
        title: 'Testdaten Resync',
        description: 'Zeigt die Buttons zum Synchronisieren der Testdaten im Portal',
        sources: ['client', 'envvar'],
        defaultValue: false,
        tags: ['portal'],
    },
};
